<!-- @format -->
<template>
    <div class="design-studio-builder-widget">
        <div class="widget-header">
            <h3>Email Designer Widget</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>

        <div class="content-wrapper"></div>

        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" :on-click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button :on-click="closeWidget">Save</app-button>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';

const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');

export default {
    name: 'design-studio-builder-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.design-studio-builder-widget .widget-footer .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
    border: 1px solid #877d88;
}

.design-studio-builder-widget .widget-footer .cancel-container .btn.transparent-btn:hover {
    background-color: #e1e0e5;
}
</style>
